module.exports = __webpack_public_path__ + "img/clipboard.fb3f7786.svg";